module.exports = __webpack_public_path__ + "img/truss_bridge_design.190a2263.jpg";